import React, { useState } from 'react';
import { CardBody, Card, CardHeader } from 'reactstrap';
import { CarouselsData } from 'Data/Bonus-ui';
import Image from 'CommonElements/Media';
import Slider from 'react-slick';
import { H5 } from 'AbstractElements';
import { useParams } from 'react-router-dom';
import {
    handleDeleteBanner,
} from './BranchUtilComponents';
import { useDispatch } from 'react-redux';

export const CarouselBannerBranch = ({ slides, rtl, title, lazyLoad, autoplay, focusOnSelect, images, setRefetch, readOnly = false, height = 'auto', width = '100%' }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    
    var settings = {
        dots: true,
        infinite: true,
        autoplay: autoplay,
        speed: 100,
        arrows: false,
        slidesToShow: slides,
        slidesToScroll: 1,
        // adaptiveHeight: true,
        autoPlay: true,
        centerPadding: '10px',
        centerMode: false,
        rtl: rtl,
        focusOnSelect: focusOnSelect,
        lazyLoad: lazyLoad,
        responsive: [
            { breakpoint: 1400, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 1200, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 1000, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 800, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ]
    };

    const [clickedIndex, setClickedIndex] = useState(null);

    const handleDelete = (pivot_id) => {
        handleDeleteBanner(dispatch, id, pivot_id, setRefetch, setClickedIndex);
    }

    return (
        <Card>
            <CardHeader className="pb-0">
                <H5>{title}</H5>
            </CardHeader>
            <CardBody>
                <Slider {...settings} >
                    {(images && images.length > 0 ? images : CarouselsData).map((item, index) => (
                        <div key={index}>
                            <Image
                                attrImage={{
                                    src: item.url || item,
                                    alt: `Slide ${index + 1}`,
                                    style: { width: width, height: height, objectFit: 'cover', borderRadius: '8px', padding: '1px' }
                                }}
                            />
                            {!readOnly && ( // Hanya tampilkan tombol delete jika bukan mode readOnly
                                <div 
                                    style={{ 
                                        width: '99%', 
                                        display: 'flex', 
                                        justifyContent: 'center', 
                                        background: clickedIndex === item.pivot_id ? '#52c41a' : '#ff4d4f',
                                        color: '#fff', 
                                        padding: '5px 0',
                                        cursor: 'pointer', 
                                        borderRadius: '0 0 8px 8px', 
                                        margin: '1px auto 0 auto'
                                    }}
                                    onClick={() => handleDelete(item.pivot_id)}
                                >
                                    <i className="icon-trash" style={{ padding: '2px 0' }}></i> Delete
                                </div>
                            )}
                        </div>
                    ))}
                </Slider>
            </CardBody>
        </Card>
    );
}

export default CarouselBannerBranch;